import React from 'react';

const LawFirmsPage = () => {
  return (
    <div>
      <h1>Law Firms</h1>
    </div>
  );
};

export default LawFirmsPage;
